import {IDialogOptionsComponent} from "../index";
import {nsModal} from "../../modal/fn";
import formatTitle = nsModal.formatTitle;
import basicHtml from './basic.html?raw';

export let template = basicHtml;

export class viewModel {

    constructor(private params: IDialogOptionsComponent) {
    }

    private getTitle() {
        return formatTitle(this.params.title);
    }

}
